<template>
  <BrandLogo type="logo" color="primary" :class="logoClass" />
</template>

<script>
import BrandLogo from "./BrandLogo.vue";

export default {
  components: {
    BrandLogo,
  },

  inject: ["brand"],

  props: {
    size: {
      type: String,
      required: false,
      default: "30px",
    },
  },

  computed: {
    logoClass() {
      return this.brand === "tidra" ? "logo logo--pulse-only" : "logo";
    },
  },
};
</script>

<style scoped>
@keyframes loading-animation {
  0% {
    transform: rotate(0deg);
    opacity: 1;
  }
  25% {
    opacity: 0.7;
  }
  50% {
    transform: rotate(360deg) scale(1);
    opacity: 1;
  }
  75% {
    transform: scale(1.3);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulse-animation {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.logo {
  animation-name: loading-animation;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  height: v-bind(size);
  width: v-bind(size);
  opacity: 0.75;
}
.logo--pulse-only {
  animation-name: pulse-animation;
  animation-duration: 1000ms;
}
</style>
